import { EApproveCalibration } from "app/calibrations/shared/calibration.model";
import { Base } from "app/shared/models/base.model";

export class ActivityVerify extends Base {

    public register: string
    public requester: string
    public interested: string
    public itemName: string
    public serialNumber: string
    public itemTag: string
    public realizationDate: Date
    public report: EApproveCalibration
    
    constructor(){
        super();
    }

    FormatedReport(): string {
        switch(this.report){
            case EApproveCalibration.Approved: return 'Aprovado';
            case EApproveCalibration.Disapproved: return 'Reprovado';
            case EApproveCalibration.ApprovedResave: return 'Aprovado com Ressalva';
            default: return '[Não Informado]';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/verify/shared/model/activity-verify.model.ts